import { observer } from 'mobx-react-lite'
import { useUi } from '@/stores/RootStore'
import { CheckIcon, CloseIcon, InfoIcon } from './icons'
import styles from './Toasts.module.css'

/**
 * Всплывающие сообщения. Один стек на приложение, живёт в оболочке.
 *
 * `role="status"` и `aria-live="polite"`: сообщение об успешном
 * выводе должно дойти и до того, кто не смотрит в правый нижний угол.
 */
export const Toasts = observer(function Toasts() {
  const ui = useUi()
  if (ui.toasts.length === 0) return null

  return (
    <div className={styles.stack} role="status" aria-live="polite">
      {ui.toasts.map((toast) => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.kind]}`}>
          <span className={styles.mark}>
            {toast.kind === 'success' ? <CheckIcon size={20} /> : <InfoIcon size={20} />}
          </span>
          <span className={styles.text}>{toast.text}</span>
          <button
            type="button"
            className={styles.close}
            onClick={() => ui.dismiss(toast.id)}
            aria-label="Закрыть"
          >
            <CloseIcon size={20} />
          </button>
        </div>
      ))}
    </div>
  )
})
